import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { PayloadStates } from '@lore/utils';
import { InContextHelpMessage } from '@communityshare/ui-shared';
import { DialogManager } from '@/dialogs_new/DialogManager';
import useDialogLauncher from '@/dialogs-routable/_hooks/useDialogLauncher';
import useMissingFields from '@/pages/event-manage/useMissingFields';

ShareEventCallout.propTypes = {
  event: PropTypes.object.isRequired
};

export default function ShareEventCallout(props) {
  const { event } = props;
  const { t } = useTranslation();
  const launch = useDialogLauncher();

  const { missingFields } = useMissingFields(event);

  // do not show this for events with missing fields
  if (
    missingFields.state !== PayloadStates.RESOLVED ||
    missingFields.data.length > 0
  ) {
    return null;
  }

  return (
    <InContextHelpMessage
      boldText={t('events.share.find_partners_callout_bold')}
      bodyText={t('events.share.find_partners_callout_body')}
      linkLabel={t('events.share.find_partners_share_link')}
      onLinkClick={() => launch(DialogManager.EventShare.Config(event.id))}
    />
  );
};
